import NewSwitch from "pages/business/Subscription/NewSwitch";

import { forwardRef } from "react";
import SettingsBasicSelect from "../../../components/Shared/SettingsBasicSelect";

const NotificationSettings = forwardRef((props: any) => {
  const { settingData, setSettingData } = props;

  const onChange = (key: any, value: any) => {
    let temp = {
      ...settingData,
      [key]: value,
    };
    setSettingData(temp);
  };

  const selectedItem = (options: any, key: any, defaultLabel: string) => {
    const keyValue = settingData[key];
    const placeHolder = options.find((i: { value: any }) => i.value == keyValue);

    return placeHolder?.label || defaultLabel;
  };

  return (
    <div className="flex container flex-col ">
      {defaultData.map((item, index) => (
        <div key={index} className="flex flex-row items-center w-full py-4 mb-6">
          <NewSwitch
            active={settingData[item.key] || undefined}
            activeColor="#30D74B"
            size={2}
            onChange={(value) => onChange(item.key, value)}
          />
          <span className="text-base mr-4 color-[#424242]">{item.label}</span>
          <div className="flex-1 flex justify-end">
            {item.timeSetting && (
              <SettingsBasicSelect
                options={item.timeSetting.options}
                onChange={(val) => {
                  onChange(item.timeSetting.key, val);
                }}
                placeholder={selectedItem(
                  item.timeSetting.options,
                  item.timeSetting.key,
                  item.timeSetting.options[0].label
                )}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
});

export default NotificationSettings;

const optionConst: {
  id: number;
  label: string;
  value: string;
}[] = [
  {
    id: 0,
    label: "همان روز",
    value: "0",
  },
  {
    id: 1,
    label: "روز قبل",
    value: "1",
  },
  {
    id: 2,
    label: "سه روز قبل",
    value: "3",
  },
  {
    id: 3,
    label: "یک هفته قبل",
    value: "7",
  },
];

const defaultData = [
  {
    label: "اعلام سررسید فاکتور فروش",
    key: "sellFactorDueDateNotification",
    timeSetting: {
      key: "sellFactorDueDateNotificationTime",
      options: optionConst,
    },
  },
  {
    label: "اعلام سررسید فاکتور خرید",
    key: "buyFactorDueDateNotification",
    timeSetting: {
      key: "buyFactorDueDateNotificationTime",
      options: optionConst,
    },
  },
  {
    label: "اعلام سررسید چک دریافتی",
    key: "receiveChequeDueDateNotification",
    timeSetting: {
      key: "receiveChequeDueDateNotificationTime",
      options: optionConst,
    },
  },
  {
    label: "اعلام سررسید چک پرداختی",
    key: "paymentChequeDueDateNotification",
    timeSetting: {
      key: "paymentChequeDueDateNotificationTime",
      options: optionConst,
    },
  },
  {
    label: "اعلام سررسید اقساط",
    key: "installmentDueDateNotification",

    timeSetting: {
      key: "installmentDueDateNotificationTime",
      options: optionConst,
    },
  },
  {
    label: "اعلام حد سفارش کالا",
    key: "productOrderLimitNotification",
    timeSetting: null,
  },
];
